import React from 'react'
import { useI18n } from '../../i18n'
import InformationSystemContextPanel from './InformationSystemContextPanel'
import styles from '../../styles/components/assets/AssetsInformationSystems.module.scss'
import type { InformationSystemDetail } from '../../services/informationSystemsApi'
import type { OperationalSummaryRow } from '../../services/informationSystemOperationalApi'
import type { BulkAssignAssetRow } from './BulkAssignAssetsModal'
import type { InformationSystemPanelContext } from './informationSystemPanelContext'
import type { InformationSystemExecutiveSummary } from '../../services/enterpriseOperationalUxApi'

interface Props {
  system: InformationSystemDetail
  summaryRow?: OperationalSummaryRow | null
  executiveSummary?: InformationSystemExecutiveSummary | null
  panelContext: InformationSystemPanelContext
  onContextChange: (ctx: InformationSystemPanelContext) => void
  inventoryAssets: BulkAssignAssetRow[]
  onClose: () => void
  onDataChanged: () => Promise<void>
  onEdit: () => void
  onDelete: () => void
  onArchive: () => void
  onLifecycleChange: (status: string) => Promise<void>
  onLinkAsset: (assetId: string) => Promise<void>
  onUnlinkAsset: (assetId: string) => Promise<void>
  onBulkLink: (assetIds: string[]) => Promise<{ linked?: Array<string | number>; skipped?: Array<string | number>; errors?: Array<{ assetId: string | number; message: string }> }>
  onBulkUnlink: (assetIds: string[]) => Promise<{ unlinked?: Array<string | number>; errors?: Array<{ assetId: string | number; message: string }> }>
  linking?: boolean
}

export default function InformationSystemPassportPanel(props: Props) {
  return <InformationSystemContextPanel {...props} />
}

export function PassportPanelEmptyState() {
  const { t } = useI18n()
  return (
    <div className={styles.detailsPanelEmpty}>
      {t('assets.postureRow.selectSystemHint', 'Select an information system to view details.')}
    </div>
  )
}
